import React, { useEffect, useState } from "react";
import { StyleSheet, Text, View } from "react-native";
import { connect } from "react-redux";
import { removeAddress } from "./../actions/user";
import { fetchApi } from "./../api";
import { STYLES } from "./../assets/styles/index";
import AddressForm from "./AddressForm";
import CustomButton from "./CustomButton";
import CustomIcon from "./CustomIcon";
import RadioBtn from "./RadioBtn";

function Addresses({
  addresses = [],
  removeAddress,
  onSelectUpdate = () => {},
  onFormShow = () => {},
  onFormHide = () => {},
}) {
  const [isReady, setIsReady] = useState(false);
  const [selected, setSelected] = useState(0);
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [editAddressInfo, setEditAddressInfo] = useState({});

  const onSelect = (data) => {
    const { address, city, state, phone, pincode, name } = data;
    onSelectUpdate({
      address,
      city,
      state,
      phone,
      pincode,
      name,
    });
  };

  useEffect(() => {
    if (addresses.length > 0) {
      onSelect(addresses[0]);
    } else {
      setShowAddressForm(true);
    }
    setIsReady(true);
  }, [addresses]);

  const handleDeleteAddress = (index, id) => {
    fetchApi({
      path: `/users/me/addresses/${id}`,
      method: "DELETE",
    }).then((res) => {
      if (!res.error) {
        removeAddress(index);
      }
    });
  };

  useEffect(() => {
    if (showAddressForm) {
      onFormShow();
    } else {
      onFormHide();
    }
  }, [showAddressForm]);

  return (
    <View style={{ flex: 1 }}>
      {isReady ? (
        !showAddressForm ? (
          <>
            {addresses.map((data, index) => (
              <View style={styles.addContainer} key={index + "ad"}>
                <View style={styles.radioBtn}>
                  <RadioBtn
                    selected={index === selected}
                    onPress={() => {
                      setSelected(index);
                      onSelect(data);
                    }}
                  />
                </View>
                <View style={{ flex: 1 }}>
                  <Text style={styles.noteBold}>{data.name}</Text>
                  <Text style={styles.noteBold}>{data.phone}</Text>
                  <Text style={styles.note}>{data.address}</Text>
                  <Text style={styles.note}>{data.city}</Text>
                  <Text style={styles.note}>{data.state}</Text>
                  <Text style={styles.note}>{data.pincode}</Text>
                </View>
                <View
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <CustomButton
                    text="Edit"
                    leftIcon={{ name: "pencil", type: "FontAwesome" }}
                    iconStyle={{
                      fontSize: STYLES.fontSizes.mini,
                      padding: 0,
                    }}
                    onPress={() => {
                      setEditAddressInfo({ index: index, initialValues: data });
                      setShowAddressForm(true);
                    }}
                    textStyle={{ color: STYLES.colors.blueGrey }}
                  />
                  <CustomIcon
                    name="delete"
                    type="AntDesign"
                    style={{
                      fontSize: STYLES.fontSizes.xlarge,
                      color: STYLES.colors.blueGrey,
                    }}
                    onPress={() => handleDeleteAddress(index, data._id)}
                  />
                </View>
              </View>
            ))}
            {addresses.length < 5 ? (
              <CustomButton
                text="Add new address"
                btnStyle={styles.btn}
                onPress={() => setShowAddressForm(true)}
                textStyle={{
                  color: "#ffffff",
                  fontSize: STYLES.fontSizes.medium,
                }}
              />
            ) : null}
          </>
        ) : (
          <AddressForm
            index={editAddressInfo.index}
            initialValues={editAddressInfo.initialValues}
            onSubmit={() => setShowAddressForm(false)}
          />
        )
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  note: { fontSize: STYLES.fontSizes.small },
  noteBold: {
    fontWeight: "bold",
    fontSize: STYLES.fontSizes.medium,
  },
  addContainer: {
    borderWidth: 1,
    flexDirection: "row",
    padding: 5,
    marginVertical: 5,
  },
  btn: {
    backgroundColor: "#000000",
    width: "90%",
    alignSelf: "center",
  },
  radioBtn: {
    paddingHorizontal: 10,
    justifyContent: "center",
    alignItems: "center",
  },
});

const mapStateToProps = (state) => ({
  addresses: state.user.addresses,
});

const mapDispatchToProps = (dispatch) => ({
  removeAddress: (data) => dispatch(removeAddress(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Addresses);
